import React from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import ProcessFormV3 from "./ProcessFormV3";
import { processApi } from "@/services/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { format } from "date-fns";
import { PROCESS_STATUS } from "@/constants/process-status";

const formatDate = (date: Date | null | undefined) => {
  if (!date) return null;
  return format(date, "yyyy-MM-dd");
};

const parseBRLCurrency = (val: any) => {
  if (!val) return 0;
  if (typeof val === "number") return val;
  const strVal = String(val);
  return parseFloat(strVal.replace(/\./g, "").replace(",", "."));
};

const NewProcess: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const createProcess = useMutation({
    mutationFn: async (data: any) => {
      const estimatedValue = String(parseBRLCurrency(data.estimated_value));

      const payload = {
        name: data.code,
        code: data.code,
        description: data.description,
        modality_id: data.modality_id,
        object: data.object,
        estimated_value: estimatedValue,
        publication_date: formatDate(data.publication_date),
        opening_date: formatDate(data.opening_date),
        opening_time: data.opening_time || null,
        responsible: data.responsible,
        status: data.status || PROCESS_STATUS.ABERTO,
      };

      const response = await processApi.create(payload);
      return response;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["processes"] });
      toast({
        title: "Processo criado com sucesso!",
        description: "O processo foi criado e adicionado à lista.",
      });
      navigate(`/processes/${data.id}`);
    },
    onError: (error: any) => {
      console.error("Error creating process:", error);
      console.error("Error response:", error.response?.data);
      toast({
        title: "Erro ao criar processo",
        description:
          error.response?.data?.publication_date?.[0] ||
          "Ocorreu um erro ao criar o processo. Por favor, tente novamente.",
        variant: "destructive",
      });
    },
  });

  const onSubmit = async (data: any) => {
    try {
      await createProcess.mutateAsync(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ProcessFormV3
      onSubmit={onSubmit}
      isEditing={false}
      submitButtonText="Criar Processo"
    />
  );
};

export default NewProcess;
